import { useState, useEffect } from 'react';
import { ncbService } from '../services/ncb';

interface User {
  id: string;
  email: string;
  name?: string;
  createdAt?: string;
}

interface Session {
  user: User | null;
  isLoading: boolean;
}

export const useAuth = () => {
  const [session, setSession] = useState<Session>({
    user: null,
    isLoading: true,
  });

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const data = await ncbService.getSession();
      setSession({ user: data.user || null, isLoading: false });
    } catch (error) {
      console.error('Session check failed:', error);
      setSession({ user: null, isLoading: false });
    }
  };

  // 🔧 修復: 使用 ncbService.signOut (統一方法名)
  const signOut = async () => {
    try {
      await ncbService.signOut();
      setSession({ user: null, isLoading: false });
      window.location.href = '/';
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };

  const refreshUser = async () => {
    setSession(prev => ({ ...prev, isLoading: true }));
    await checkSession();
  };

  return {
    user: session.user,
    isLoading: session.isLoading,
    isAuthenticated: !!session.user,
    signOut,
    refreshSession: checkSession,
    refreshUser,
  };
};